import { MenuItem, Select, SelectChangeEvent, styled } from "@mui/material";
import { useUrlSelectLayer } from "hooks/layerSetHooks";
import { Layer } from "types/types";

interface Props {
  layerList: Layer[];
}

export function LayerSetSelect(props: Props) {
  const { layerList } = props;
  const { selectedLayer, selectLayer } = useUrlSelectLayer(layerList);
  return (
    <StyledSelect
      size="small"
      MenuProps={{ disablePortal: true }}
      fullWidth
      value={selectedLayer.id}
      onChange={(e: SelectChangeEvent<number>) => {
        selectLayer(+e.target.value);
      }}
    >
      {layerList.map((layer) => (
        <MenuItem key={layer.id} value={layer.id}>
          {layer.uniqueName}
        </MenuItem>
      ))}
    </StyledSelect>
  );
}

const StyledSelect = styled(Select<number>)`
  margin-top: ${({ theme }) => theme.spacing(1)};
  .MuiMenu-root {
    max-height: 60vh;
  }
`;
